var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "cancel_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v34H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cancel_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.167 17c0 7.823-6.343 14.167-14.167 14.167-7.823 0-14.166-6.344-14.166-14.167C2.834 9.176 9.177 2.833 17 2.833c7.824 0 14.167 6.343 14.167 14.167z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.007 10.99l2.003 2.004-10.016 10.015-2.003-2.003 10.016-10.015z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.01 21.006l-2.003 2.003L10.99 12.994l2.003-2.003L23.01 21.006z",
    fill: "#fff"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzQiIGhlaWdodD0iMzQiPgo8cmVjdCB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMCkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMxLjE2NjggMTdDMzEuMTY2OCAyNC44MjM1IDI0LjgyMzcgMzEuMTY2NiAxNy4wMDAyIDMxLjE2NjZDOS4xNzY2MiAzMS4xNjY2IDIuODMzNSAyNC44MjM1IDIuODMzNSAxN0MyLjgzMzUgOS4xNzY0NCA5LjE3NjYyIDIuODMzMzEgMTcuMDAwMiAyLjgzMzMxQzI0LjgyMzcgMi44MzMzMSAzMS4xNjY4IDkuMTc2NDQgMzEuMTY2OCAxN1oiIGZpbGw9IiNGN0I1MDAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS4wMDY2IDEwLjk5MDVMMjMuMDA5NyAxMi45OTM2TDEyLjk5MzkgMjMuMDA5NUwxMC45OTA3IDIxLjAwNjNMMjEuMDA2NiAxMC45OTA1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMy4wMDk3IDIxLjAwNjNMMjEuMDA2NiAyMy4wMDk1TDEwLjk5MDcgMTIuOTkzNkwxMi45OTM5IDEwLjk5MDVMMjMuMDA5NyAyMS4wMDYzWiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K";
export { SvgCancel as ReactComponent };